/**
 * Clears errors on state transition
 */
export const clearErrorHook = (app) => {
  app.run(($transitions) => {
    'ngInject';

    let clearErrorFn = (trans) => {
      let errorService = trans.injector().get('errorService');
      errorService.clear();
    };

    $transitions.onBefore({ }, clearErrorFn);
  });
};